// Mock data for Midtown Earth Solutions LLC

export const companyInfo = {
  name: "Midtown Earth Solutions LLC",
  phone: "+1 706-366-3685",
  email: "Richard@midtownearthsolutionsga.com",
  address: "1127 Virginia St, Columbus, GA 31901, United States",
  hours: "Monday - Friday: 8:00 AM - 5:00 PM",
  tagline: "Premium Landscaping Materials & Reliable Delivery",
  description: "Your trusted partner for high-quality landscaping materials and professional delivery services in Columbus, GA and surrounding areas.",
  googleBusinessUrl: "https://share.google/G1CSXh5GHoq9Fbav4"
};

export const products = [
  {
    id: 1,
    name: "Premium Gravel",
    image: "/products/premium-gravel.jpg",
    description: "High-quality gravel perfect for driveways, pathways, and decorative landscaping.",
    priceRange: "Call for current pricing",
    applications: ["Driveways", "Pathways", "Drainage", "Decorative landscaping"],
    category: "Stone & Gravel"
  },
  {
    id: 2,
    name: "57 Stone",
    image: "/products/57-stone.jpg",
    description: "Versatile crushed stone aggregate ideal for construction and drainage projects.",
    priceRange: "Call for current pricing",
    applications: ["Construction base", "Drainage systems", "Concrete projects", "Road base"],
    category: "Stone & Gravel"
  },
  {
    id: 3,
    name: "Pea Gravel",
    image: "/products/pea-gravel.jpg",
    description: "Small, smooth stones ideal for pathways, patios, and decorative ground cover.",
    priceRange: "Call for current pricing",
    applications: ["Pathways", "Patios", "Ground cover", "Play areas"],
    category: "Stone & Gravel"
  },
  {
    id: 4,
    name: "River Rock",
    image: "/products/river-rock.jpg",
    description: "Smooth, decorative stones perfect for landscaping and water features.",
    priceRange: "Call for current pricing",
    applications: ["Landscaping", "Water features", "Drainage", "Decorative borders"],
    category: "Decorative Stone"
  },
  {
    id: 5,
    name: "Crusher Run",
    image: "/products/crusher-run.jpg",
    description: "Compactable gravel blend excellent for driveways and base material.",
    priceRange: "Call for current pricing",
    applications: ["Driveway base", "Road base", "Parking areas", "Foundation"],
    category: "Stone & Gravel"
  },
  {
    id: 6,
    name: "Premium Sand",
    image: "/products/premium-sand.jpg",
    description: "Clean, fine sand suitable for construction, landscaping, and play areas.",
    priceRange: "Call for current pricing",
    applications: ["Construction", "Sandboxes", "Paver base", "Landscaping"],
    category: "Sand & Soil"
  },
  {
    id: 7,
    name: "Natural Mulch",
    image: "/products/natural-mulch.jpg",
    description: "Premium wood mulch that enriches soil and enhances garden aesthetics.",
    priceRange: "Call for current pricing",
    applications: ["Garden beds", "Tree rings", "Erosion control", "Weed prevention"],
    category: "Mulch & Organic"
  },
  {
    id: 8,
    name: "Rich Topsoil",
    image: "/products/rich-topsoil.jpg",
    description: "Nutrient-rich topsoil perfect for planting, gardening, and lawn establishment.",
    priceRange: "Call for current pricing",
    applications: ["Lawn establishment", "Garden beds", "Planting", "Soil amendment"],
    category: "Sand & Soil"
  },
  {
    id: 9,
    name: "Fill Dirt",
    image: "/products/fill-dirt.jpg",
    description: "Quality fill dirt for grading, leveling, and large-scale earthwork projects.",
    priceRange: "Call for current pricing",
    applications: ["Site grading", "Foundation fill", "Landscape leveling", "Large projects"],
    category: "Sand & Soil"
  },
  {
    id: 10,
    name: "Red Clay",
    image: "/products/red-clay.jpg",
    description: "Dense clay material perfect for sculpting landscapes and erosion control.",
    priceRange: "Call for current pricing",
    applications: ["Erosion control", "Pond lining", "Sculpting", "Fill material"],
    category: "Sand & Soil"
  },
  {
    id: 11,
    name: "Compost",
    image: "/products/compost.jpg",
    description: "Organic compost to enrich soil and promote healthy plant growth.",
    priceRange: "Call for current pricing",
    applications: ["Soil amendment", "Garden beds", "Lawn top dressing", "Plant nutrition"],
    category: "Mulch & Organic"
  },
  {
    id: 12,
    name: "Decorative Rock",
    image: "/products/decorative-rock.jpg",
    description: "Attractive decorative stones in various colors for landscaping accents.",
    priceRange: "Call for current pricing",
    applications: ["Landscape accents", "Garden borders", "Water features", "Ground cover"],
    category: "Decorative Stone"
  }
];

export const serviceAreas = [
  {
    id: 1,
    name: "Columbus, GA",
    description: "Full service coverage throughout Columbus and surrounding neighborhoods."
  },
  {
    id: 2,
    name: "Midland, GA",
    description: "Reliable delivery throughout Midland and the surrounding North Columbus area."
  },
  {
    id: 3,
    name: "Hamilton, GA",
    description: "Serving Hamilton with prompt delivery of all landscaping materials."
  },
  {
    id: 4,
    name: "Box Springs, GA",
    description: "Quality material delivery to Box Springs and nearby communities."
  },
  {
    id: 5,
    name: "Fortson, GA",
    description: "Trusted material supply for Fortson residential and commercial projects."
  },
  {
    id: 6,
    name: "Cataula, GA",
    description: "Dependable delivery services throughout Cataula and Harris County."
  },
  {
    id: 7,
    name: "Wesley Heights",
    description: "Professional material delivery to Wesley Heights and surrounding neighborhoods."
  },
  {
    id: 8,
    name: "Phenix City, AL",
    description: "Reliable delivery services across Phenix City and Russell County."
  },
  {
    id: 9,
    name: "Harris County, GA",
    description: "Serving all of Harris County with professional material delivery."
  },
  {
    id: 10,
    name: "Muscogee County, GA",
    description: "Complete coverage of Muscogee County for all your material needs."
  }
];

export const services = [
  {
    slug: "gravel-delivery",
    name: "Gravel Delivery",
    shortName: "Gravel",
    heroImage: "/products/premium-gravel.jpg",
    tagline: "Premium Gravel Delivered Across Columbus, GA",
    description: "Reliable gravel delivery for driveways, pathways, drainage, and landscaping projects throughout Columbus and surrounding areas.",
    longDescription: "Our premium gravel is sourced for consistency, color, and durability. Whether you're a homeowner refreshing a driveway or a contractor building a parking pad, we deliver the right quantity, on time, and exactly where you need it. With same-day options available in Columbus and Muscogee County, your project never has to wait.",
    benefits: [
      "Consistent stone size and quality",
      "Excellent for driveways and pathways",
      "Available in bulk quantities",
      "Precise placement by professional drivers",
      "Same-day delivery for Columbus orders",
      "Transparent pricing — no hidden fees"
    ],
    applications: ["Residential driveways", "Commercial parking areas", "Garden pathways", "Drainage systems", "Decorative landscaping", "Construction base"],
    keywords: "gravel delivery Columbus GA, residential gravel, commercial gravel delivery, driveway gravel",
    seoTitle: "Gravel Delivery in Columbus, GA | Same-Day Available | Midtown Earth Solutions"
  },
  {
    slug: "57-stone-delivery",
    name: "57 Stone Delivery",
    shortName: "57 Stone",
    heroImage: "/products/57-stone.jpg",
    tagline: "Versatile 57 Stone for Construction & Drainage",
    description: "High-quality 57 Stone aggregate delivered for construction, drainage, and landscape projects across the Columbus region.",
    longDescription: "57 Stone is the workhorse of construction aggregates — 3/4-inch crushed stone with no fines, perfect for drainage, concrete mix, French drains, and as a finishing layer on driveways. We deliver 57 Stone in any quantity, from a single yard for a backyard project to multiple truckloads for commercial sites.",
    benefits: [
      "Superior drainage characteristics",
      "Clean, washed crushed stone",
      "Ideal for concrete and drainage projects",
      "Bulk pricing for contractors",
      "Reliable scheduling for job sites",
      "Same-day delivery options"
    ],
    applications: ["French drains", "Concrete projects", "Pipe bedding", "Driveway top layer", "Foundation drainage", "Road construction base"],
    keywords: "57 stone Columbus GA, 57 stone delivery, crushed stone aggregate, drainage stone",
    seoTitle: "57 Stone Delivery in Columbus, GA | Bulk Aggregate | Midtown Earth Solutions"
  },
  {
    slug: "sand-delivery",
    name: "Sand Delivery",
    shortName: "Sand",
    heroImage: "/products/premium-sand.jpg",
    tagline: "Clean, Premium Sand for Every Project",
    description: "Professional sand delivery for construction, paver bases, sandboxes, and landscaping needs in Columbus, GA.",
    longDescription: "We supply clean, screened sand for every type of project — from masonry and concrete work to children's sandboxes and paver foundations. Our sand is consistent in grain size and free of debris. Delivered by truck to your home, job site, or yard across the Columbus region.",
    benefits: [
      "Clean, screened, debris-free sand",
      "Consistent grain size",
      "Safe for play areas",
      "Excellent paver base material",
      "Bulk quantities available",
      "Affordable per-ton pricing"
    ],
    applications: ["Paver and brick base", "Concrete mixing", "Sandboxes", "Volleyball courts", "Pipe bedding", "Landscape leveling"],
    keywords: "sand delivery Columbus GA, masonry sand, paver sand, play sand",
    seoTitle: "Sand Delivery in Columbus, GA | Paver, Masonry, Play Sand | Midtown Earth"
  },
  {
    slug: "mulch-delivery",
    name: "Mulch Delivery",
    shortName: "Mulch",
    heroImage: "/products/natural-mulch.jpg",
    tagline: "Premium Mulch Delivered to Your Garden",
    description: "Natural hardwood mulch and pine bark delivered for garden beds, tree rings, and landscape projects throughout Columbus, GA.",
    longDescription: "Mulch isn't just decorative — it's one of the most powerful tools in your landscape. Our premium hardwood and pine bark mulches retain moisture, suppress weeds, and slowly enrich your soil. We deliver mulch by the cubic yard, so you only pay for what you need.",
    benefits: [
      "Premium hardwood and pine bark options",
      "Cuts watering needs by up to 50%",
      "Suppresses weed growth naturally",
      "Reduces soil temperature in Georgia heat",
      "Enriches soil as it decomposes",
      "Per-cubic-yard delivery"
    ],
    applications: ["Garden beds", "Tree rings", "Foundation plantings", "Shrub borders", "Erosion control", "Playground surfacing"],
    keywords: "mulch delivery Columbus GA, hardwood mulch, pine bark mulch, garden mulch",
    seoTitle: "Mulch Delivery in Columbus, GA | Hardwood & Pine Bark | Midtown Earth"
  },
  {
    slug: "topsoil-delivery",
    name: "Topsoil Delivery",
    shortName: "Topsoil",
    heroImage: "/products/rich-topsoil.jpg",
    tagline: "Rich, Nutrient-Dense Topsoil for Growing",
    description: "Premium topsoil delivered for lawns, gardens, and landscape projects across Columbus, GA and the surrounding region.",
    longDescription: "If you want plants to thrive, start with the right soil. Our nutrient-rich topsoil is loose, dark, and full of organic matter — ideal for new lawns, vegetable gardens, raised beds, and any planting project. Delivered by the cubic yard exactly where you need it.",
    benefits: [
      "Rich in organic matter and nutrients",
      "Excellent moisture retention",
      "Ideal for new lawn installation",
      "Perfect for vegetable gardens",
      "Loose, easy-to-spread texture",
      "Screened to remove debris"
    ],
    applications: ["New lawn installation", "Vegetable gardens", "Raised garden beds", "Lawn top dressing", "Flower beds", "Plant nutrition"],
    keywords: "topsoil delivery Columbus GA, garden topsoil, lawn soil, screened topsoil",
    seoTitle: "Topsoil Delivery in Columbus, GA | Premium Garden Soil | Midtown Earth"
  },
  {
    slug: "river-rock-delivery",
    name: "River Rock Delivery",
    shortName: "River Rock",
    heroImage: "/products/river-rock.jpg",
    tagline: "Beautiful River Rock for Stunning Landscapes",
    description: "Smooth decorative river rock delivered for landscaping accents, drainage, and water features throughout Columbus, GA.",
    longDescription: "River rock is the premium choice for homeowners and designers who want elegant, low-maintenance landscaping. The smooth, naturally tumbled stones come in earth-tone colors that complement any home. We deliver river rock by the ton, perfect for both decorative accents and functional drainage.",
    benefits: [
      "Naturally smooth, tumbled stones",
      "Beautiful earth-tone color variation",
      "Long-lasting and low-maintenance",
      "Functional for drainage too",
      "Adds curb appeal and value",
      "Bulk delivery available"
    ],
    applications: ["Landscape borders", "Decorative ground cover", "Water features and ponds", "Dry creek beds", "Drainage swales", "Walkway accents"],
    keywords: "river rock delivery Columbus GA, decorative landscaping stone, smooth river rock",
    seoTitle: "River Rock Delivery in Columbus, GA | Decorative Stone | Midtown Earth"
  }
];

export const gallery = {
  materials: [
    { id: 1, src: "/products/premium-gravel.jpg", alt: "Premium gravel close-up", caption: "Premium Gravel" },
    { id: 2, src: "/products/57-stone.jpg", alt: "57 Stone aggregate", caption: "57 Stone Aggregate" },
    { id: 3, src: "/products/premium-sand.jpg", alt: "Clean screened sand", caption: "Clean Sand" },
    { id: 4, src: "/products/natural-mulch.jpg", alt: "Hardwood mulch", caption: "Natural Mulch" },
    { id: 5, src: "/products/rich-topsoil.jpg", alt: "Rich dark topsoil", caption: "Rich Topsoil" },
    { id: 6, src: "/products/fill-dirt.jpg", alt: "Fill dirt", caption: "Fill Dirt" }
  ],
  delivery: [
    { id: 1, src: "https://images.unsplash.com/photo-1769629918261-92d1fac176cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxkdW1wJTIwdHJ1Y2slMjBtYXRlcmlhbCUyMHlhcmR8ZW58MHx8fHwxNzgwMTg4Njk3fDA&ixlib=rb-4.1.0&q=85", alt: "Aerial material yard view", caption: "Our Material Yard" },
    { id: 2, src: "https://images.pexels.com/photos/29174547/pexels-photo-29174547.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", alt: "Dump truck unloading gravel", caption: "Gravel Delivery" },
    { id: 3, src: "https://images.unsplash.com/photo-1671022412547-75c4cb01f47e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxkdW1wJTIwdHJ1Y2slMjBkZWxpdmVyeXxlbnwwfHx8fDE3ODAxODg3NTN8MA&ixlib=rb-4.1.0&q=85", alt: "Active dump truck delivery", caption: "On-Site Delivery" },
    { id: 4, src: "/products/delivery-driveway.jpg", alt: "Dump truck unloading gravel onto a residential driveway", caption: "Driveway Delivery" }
  ],
  projects: [
    { id: 1, src: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc4MDE4ODc3Mnww&ixlib=rb-4.1.0&q=85", alt: "Construction site team", caption: "Commercial Project" },
    { id: 2, src: "/products/landscape-project.jpg", alt: "Finished residential landscaping with mulch beds and river rock borders", caption: "Completed Landscape Project" },
    { id: 3, src: "https://images.unsplash.com/photo-1604178449672-3e7d72d5a09a", alt: "Finished gravel driveway", caption: "Driveway Project" }
  ]
};

export const blogPosts = [
  {
    id: 1,
    slug: "how-much-gravel-driveway-columbus-ga",
    title: "How Much Gravel Do You Need for Your Driveway? A Columbus, GA Homeowner's Guide",
    excerpt: "Planning a new gravel driveway in Columbus, GA? Learn exactly how to calculate the tons of gravel you need, choose the right stone, and avoid costly mistakes.",
    image: "https://images.unsplash.com/photo-1604178449672-3e7d72d5a09a",
    category: "Driveways",
    author: "Midtown Earth Solutions",
    date: "December 1, 2025",
    readTime: "6 min read",
    keywords: "gravel driveway Columbus GA, how much gravel do I need, driveway gravel calculator, gravel delivery Columbus",
    content: `If you're a Columbus, GA homeowner planning a new gravel driveway, the first question is always the same: how much gravel do I actually need? Getting the calculation right is critical — order too little and you'll have bare patches; order too much and you've wasted money.\n\nAt Midtown Earth Solutions, we deliver gravel daily to homes throughout Columbus, Midland, Fortson, and the entire Muscogee County area. Here's the straightforward formula our customers use.\n\n## The Simple Gravel Calculation Formula\n\nTo estimate the gravel you need for any driveway:\n\n**Length (ft) × Width (ft) × Depth (ft) ÷ 27 = Cubic Yards**\n\nThen multiply cubic yards by 1.4 to get approximate tons (gravel weighs about 1.4 tons per cubic yard).\n\n### Example: A Standard Columbus Driveway\n\nFor a typical 50 ft × 12 ft driveway with 4 inches of gravel (0.33 ft):\n\n- 50 × 12 × 0.33 = 198 cubic feet\n- 198 ÷ 27 = 7.3 cubic yards\n- 7.3 × 1.4 = approximately 10.2 tons of gravel\n\n## Recommended Gravel Depth for Driveways\n\n- **New driveways:** 4-6 inches total (a base layer plus a top layer)\n- **Refresh existing driveways:** 1-2 inches of new gravel\n- **Heavy vehicle access:** Up to 8 inches with a compactable base\n\n## Best Gravel Types for Columbus, GA Driveways\n\n1. **Crusher Run** — Compacts beautifully, ideal as a base layer\n2. **57 Stone** — Excellent drainage, perfect top layer\n3. **Pea Gravel** — Smooth and attractive, best for low-traffic driveways\n\n## Avoid These Common Mistakes\n\n- Skipping a proper base layer (leads to ruts within months)\n- Ordering only enough for one layer when two are needed\n- Not accounting for settlement (gravel compacts about 20%)\n\n## Ready to Order Your Driveway Gravel?\n\nOur team delivers same-day to most of Columbus and Muscogee County. Call us at (706) 366-3685 and we'll help you calculate the exact tonnage for your driveway — and get it delivered when you need it.`
  },
  {
    id: 2,
    slug: "57-stone-vs-crusher-run",
    title: "57 Stone vs Crusher Run: Which One Is Right for Your Project?",
    excerpt: "Confused between 57 Stone and Crusher Run? We break down the differences, best uses, and how to choose the right aggregate for your Columbus, GA project.",
    image: "https://images.pexels.com/photos/5799727/pexels-photo-5799727.jpeg",
    category: "Materials Guide",
    author: "Midtown Earth Solutions",
    date: "November 24, 2025",
    readTime: "5 min read",
    keywords: "57 stone vs crusher run, 57 stone Columbus GA, crusher run driveway, aggregate stone comparison",
    content: `When customers call us in Columbus, GA asking about driveway and base materials, two products come up constantly: 57 Stone and Crusher Run. They look similar at first glance, but they serve very different purposes. Choosing the wrong one can mean redoing the whole project.\n\n## What Is 57 Stone?\n\n57 Stone is a crushed gravel aggregate with stones roughly 3/4 inch in size. It contains no fines (small dust particles), which gives it excellent drainage properties. Water flows right through.\n\n**Best uses for 57 Stone:**\n- Top layer of driveways\n- Drainage systems and French drains\n- Concrete mix base\n- Around foundations and pipes\n- Walkways and patios\n\n## What Is Crusher Run?\n\nCrusher Run (also called "Crush and Run" or "ABC Stone") is a blend of crushed stone and stone dust. The mix of sizes lets it compact tightly into a hard, stable surface.\n\n**Best uses for Crusher Run:**\n- Driveway base layers\n- Road base\n- Parking pad foundations\n- Shed and building pads\n- Anywhere you need a hard-packed surface\n\n## Side-by-Side Comparison\n\n| Feature | 57 Stone | Crusher Run |\n|---------|----------|-------------|\n| Drainage | Excellent | Poor (by design) |\n| Compaction | Loose | Compacts hard |\n| Surface feel | Loose stones | Solid/firm |\n| Best as | Top layer | Base layer |\n\n## The Ideal Driveway Combo\n\nFor a long-lasting Columbus driveway, most contractors use both:\n\n1. **Base layer:** 4 inches of Crusher Run, compacted\n2. **Top layer:** 2 inches of 57 Stone for drainage and appearance\n\nThis gives you a firm, stable driveway that drains well during heavy Georgia rainfall.\n\n## Which Is More Affordable?\n\nPricing is very similar for both materials. The real question isn't price — it's matching the material to the job.\n\n## Get Expert Advice on Your Project\n\nNot sure which to order? Call us at (706) 366-3685. We'll ask a few quick questions about your project and recommend the right mix and quantity. We deliver throughout Columbus, Midland, Hamilton, Fortson, and the entire region.`
  },
  {
    id: 3,
    slug: "best-mulch-georgia-gardens",
    title: "The Best Mulch for Georgia Gardens: A Complete Guide",
    excerpt: "Discover which mulch performs best in Georgia's hot, humid climate. Save water, suppress weeds, and grow healthier plants with the right mulch choice.",
    image: "https://images.pexels.com/photos/11742397/pexels-photo-11742397.jpeg",
    category: "Landscaping",
    author: "Midtown Earth Solutions",
    date: "November 17, 2025",
    readTime: "7 min read",
    keywords: "best mulch Georgia, mulch Columbus GA, garden mulch types, wood mulch delivery",
    content: `Georgia's hot summers and humid climate put real stress on garden beds. The right mulch is one of the most powerful tools you have to keep plants healthy, reduce watering, and stop weeds in their tracks.\n\nAfter years of delivering mulch throughout the Columbus area, here's what we've learned about choosing the best mulch for our climate.\n\n## Why Mulch Matters So Much in Georgia\n\nProper mulching can:\n\n- **Reduce watering by up to 50%** during summer\n- **Drop soil temperature 10-15°F** in direct sun\n- **Suppress 70-90% of weed growth**\n- **Prevent erosion** during summer thunderstorms\n- **Add organic matter** as it breaks down\n\n## Top Mulch Types for Georgia\n\n### 1. Hardwood Mulch (Best All-Around)\n\nOur most popular mulch. Made from shredded hardwood, it's long-lasting, looks great, and breaks down slowly to enrich soil.\n\n**Best for:** Trees, shrubs, perennial beds, foundation plantings\n\n### 2. Pine Bark Mulch\n\nNaturally acidic, making it perfect for acid-loving plants common in Georgia.\n\n**Best for:** Azaleas, camellias, blueberries, hydrangeas\n\n### 3. Pine Straw\n\nA Southern favorite. Lightweight, slip-resistant on slopes, and slightly acidic.\n\n**Best for:** Slopes, large beds, natural-looking landscapes\n\n### 4. Compost Mulch\n\nThe most nutritious option. Doubles as a soil amendment.\n\n**Best for:** Vegetable gardens, intensive flower beds\n\n## How Much Mulch Do You Need?\n\n**Formula:** Square feet × desired depth (in feet) ÷ 27 = cubic yards\n\nFor most Georgia gardens, apply mulch 2-3 inches deep:\n\n- 100 sq ft × 3 inches (0.25 ft) ÷ 27 = 0.93 cubic yards\n\n## When to Mulch in Georgia\n\n- **Spring (March-April):** Refresh mulch before summer heat\n- **Fall (October-November):** Insulate roots for winter\n\n## Mistakes to Avoid\n\n- **Volcano mulching** (piling mulch against tree trunks) — kills trees\n- **Too thick** (over 4 inches) — suffocates roots\n- **Too thin** (under 2 inches) — fails to suppress weeds\n\n## Order Mulch Delivered to Your Door\n\nWe deliver premium mulch and compost throughout Columbus, Midland, Cataula, Fortson, and Harris County. Call (706) 366-3685 for same-day quotes and we'll help you choose the perfect mulch for your garden.`
  },
  {
    id: 4,
    slug: "topsoil-vs-fill-dirt",
    title: "Topsoil vs Fill Dirt: Don't Confuse These (It Could Cost You)",
    excerpt: "Topsoil and fill dirt look similar but serve completely different purposes. Learn what each is for and when to use them on your Columbus, GA property.",
    image: "https://images.pexels.com/photos/12940879/pexels-photo-12940879.jpeg",
    category: "Materials Guide",
    author: "Midtown Earth Solutions",
    date: "November 10, 2025",
    readTime: "5 min read",
    keywords: "topsoil vs fill dirt, topsoil Columbus GA, fill dirt delivery, lawn soil",
    content: `One of the most common mistakes homeowners make is ordering the wrong type of dirt. Topsoil and fill dirt may look almost identical when delivered, but using fill dirt where topsoil is needed (or vice versa) leads to dead plants, sinking foundations, and wasted money.\n\nHere's exactly how to know which one you need.\n\n## What Is Topsoil?\n\nTopsoil is the nutrient-rich upper layer of soil — typically the top 4-12 inches of natural ground. It contains organic matter, microbes, and the nutrients plants need to grow.\n\n**Key features:**\n- Dark color\n- Loose, crumbly texture\n- Holds moisture well\n- Full of nutrients\n\n**Use topsoil for:**\n- Starting a new lawn\n- Garden beds\n- Vegetable gardens\n- Top-dressing existing yards\n- Anywhere plants will grow\n\n## What Is Fill Dirt?\n\nFill dirt is subsoil — the dirt that sits beneath the topsoil. It has little to no organic material, doesn't support plant growth well, but compacts firmly and won't shift much over time.\n\n**Key features:**\n- Lighter color, sometimes red or clay-like\n- Denser, often contains rocks or clay\n- Doesn't hold many nutrients\n- Compacts to a stable surface\n\n**Use fill dirt for:**\n- Filling in low spots in yards\n- Building up grade around foundations\n- Filling old pools or large holes\n- Creating berms or sloped areas\n- Large landscaping projects\n\n## The Critical Difference\n\nFill dirt is structural. Topsoil is biological.\n\nIf you build up an area with topsoil, it will compress, sink, and shift — your project will fail.\n\nIf you plant grass or flowers in fill dirt, almost nothing will grow.\n\n## Common Project Examples\n\n### Filling a Low Spot Then Growing Grass\nLayer fill dirt to raise the grade, then top with 4-6 inches of topsoil before seeding.\n\n### Building a Raised Garden Bed\nUse topsoil mixed with compost — never fill dirt alone.\n\n### Filling an Old Swimming Pool\nUse fill dirt for the bulk of the volume, topsoil only at the surface if planting.\n\n## Red Clay vs Fill Dirt\n\nIn Georgia, you'll also see red clay sold separately. It's similar to fill dirt but denser and more impermeable — great for pond bottoms or erosion barriers.\n\n## How Much Do You Need?\n\nUse this formula:\n\n**Length × Width × Depth (all in feet) ÷ 27 = Cubic Yards**\n\nMost dump truck deliveries carry 10-15 cubic yards per load.\n\n## Need Help Deciding?\n\nCall (706) 366-3685 and tell us what you're working on. We'll recommend the right material and quantity, and deliver it where you need it across Columbus, Midland, Fortson, and beyond.`
  },
  {
    id: 5,
    slug: "landscaping-cost-guide-columbus-ga",
    title: "Landscaping Materials Cost Guide for Columbus, GA Homeowners",
    excerpt: "Budgeting for a landscaping project? Get a realistic breakdown of material costs, delivery factors, and money-saving tips from local Columbus experts.",
    image: "https://images.pexels.com/photos/29174547/pexels-photo-29174547.jpeg",
    category: "Pricing",
    author: "Midtown Earth Solutions",
    date: "November 3, 2025",
    readTime: "6 min read",
    keywords: "landscaping cost Columbus GA, gravel prices, mulch delivery cost, topsoil price",
    content: `Planning a landscaping project in Columbus, GA? Knowing what materials cost — and what affects pricing — helps you budget accurately and avoid surprise costs.\n\nThis guide breaks down what local homeowners typically spend on common landscaping materials, plus tips to stretch your budget.\n\n## Factors That Affect Material Pricing\n\nMaterial costs vary based on:\n\n1. **Material type** (decorative stone costs more than fill dirt)\n2. **Quantity ordered** (bulk orders get better per-ton pricing)\n3. **Delivery distance** (closer = lower fees)\n4. **Time of year** (spring/fall demand peaks)\n5. **Truck access** (tight properties may require smaller trucks)\n\n## Typical Material Cost Ranges\n\n### Gravel & Stone Aggregates\n- **Crusher Run** — most affordable per ton\n- **57 Stone** — mid-range pricing\n- **Pea Gravel** — slightly higher\n- **Decorative Rock** — premium pricing\n\n### Sand & Soil\n- **Fill Dirt** — lowest cost per yard\n- **Sand** — affordable, varies by grade\n- **Topsoil** — mid-range\n- **Premium garden mix** — higher\n\n### Mulch & Organic\n- **Hardwood Mulch** — moderate cost per yard\n- **Pine Bark** — slightly higher\n- **Compost** — varies by quality\n\nFor exact current pricing, call (706) 366-3685 — we provide real-time quotes based on your project specifics.\n\n## How to Get the Best Value\n\n### 1. Order in Bulk\nOne large delivery is dramatically cheaper than several small ones. Plan your full project, then order once.\n\n### 2. Combine Materials\nNeed both gravel and topsoil? Ask about combo delivery — we can often save you a delivery fee.\n\n### 3. Schedule Smartly\nWeekday deliveries are typically more flexible than peak weekend hours.\n\n### 4. Account for Waste\nAdd 10-15% to your estimate. Running short means an expensive second delivery.\n\n### 5. Pick the Right Quality\nDon't overpay for premium materials where standard grade works. Don't underpay where quality matters (like topsoil for a new lawn).\n\n## Typical Project Material Budgets\n\n### Standard Driveway Refresh\n4-6 tons of gravel for an average residential driveway\n\n### Garden Bed Refresh\n2-4 cubic yards of mulch for typical landscape beds\n\n### New Lawn Installation\n6-10 cubic yards of quality topsoil for an average yard\n\n### Pool Removal Fill\n40-80 cubic yards of fill dirt depending on pool size\n\n## Get an Accurate Quote in Minutes\n\nGeneric pricing only goes so far. For an exact, no-obligation quote tailored to your project and delivery location, call (706) 366-3685 or request a quote online. We serve Columbus, Midland, Hamilton, Cataula, Fortson, Phenix City, and the entire region.`
  },
  {
    id: 6,
    slug: "preparing-driveway-gravel-delivery",
    title: "How to Prepare for a Gravel Delivery: A Homeowner's Checklist",
    excerpt: "Make your gravel delivery smooth and stress-free. Follow this simple checklist to prepare your property and ensure the driver can place materials exactly where you need them.",
    image: "https://images.unsplash.com/photo-1671022412547-75c4cb01f47e",
    category: "Delivery Tips",
    author: "Midtown Earth Solutions",
    date: "October 27, 2025",
    readTime: "4 min read",
    keywords: "gravel delivery preparation, dump truck delivery, prepare for material delivery Columbus GA",
    content: `A gravel or material delivery is straightforward, but a few minutes of preparation makes the whole process smoother. Use this quick checklist before your delivery arrives.\n\n## Before the Delivery Day\n\n### 1. Choose Your Drop Location\nThink about where you want the material:\n- Easy access for moving the material later\n- Off pavement that could be damaged\n- Away from septic tanks, irrigation, or buried utilities\n- On a flat surface if possible\n\n### 2. Measure Your Access\nOur dump trucks need:\n- About 12 feet of clear width\n- 14 feet of overhead clearance\n- A turnaround area or pull-through option\n\n### 3. Clear Obstacles\nMove vehicles, trash bins, kids' toys, and patio furniture out of the truck's path.\n\n### 4. Check Overhead\nLow-hanging branches and power lines are the most common delivery problems. Trim branches if needed.\n\n## Day of Delivery\n\n### 5. Mark the Exact Spot\nA piece of cardboard, spray paint, or a tarp marks the drop location clearly for the driver.\n\n### 6. Be Available (or Leave Clear Instructions)\nIf you can't be home, leave a note with:\n- Drop location\n- Best path to the spot\n- Any special instructions\n- A contact phone number\n\n### 7. Protect Soft Surfaces\nLay plywood sheets if you're worried about lawn damage. Heavy trucks can leave ruts in wet grass.\n\n## After the Drop\n\n### 8. Cover If Rain Is Coming\nLight materials (mulch, topsoil) can wash or scatter. A tarp protects them.\n\n### 9. Move Material Promptly\nThe sooner you spread or move it, the less stress on whatever surface it sits on.\n\n## Special Situations\n\n### Steep Driveways\nLet us know in advance. We may need to position differently or recommend a smaller delivery.\n\n### Gated Communities\nProvide gate codes when you book.\n\n### Tight Urban Lots\nWe have smaller trucks for these situations. Just mention it when ordering.\n\n## Ready to Schedule?\n\nCall (706) 366-3685 to schedule your delivery. Tell us about your property and we'll match the right truck and timing. Same-day delivery available throughout Columbus, Midland, Fortson, and Muscogee County.`
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Robert Mitchell",
    role: "General Contractor",
    content: "Midtown Earth Solutions has been my go-to supplier for three years. Their materials are top-quality, delivery is always on time, and their prices are unbeatable. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Thompson",
    role: "Landscape Designer",
    content: "The team at Midtown Earth Solutions always delivers exactly what I need, when I need it. Their customer service is exceptional, and the quality of materials is consistently excellent.",
    rating: 5
  },
  {
    id: 3,
    name: "James Rodriguez",
    role: "Homeowner",
    content: "I needed gravel for my driveway and topsoil for my garden. The entire process was seamless - from ordering to delivery. The driver was professional and placed everything exactly where I wanted it.",
    rating: 5
  },
  {
    id: 4,
    name: "Emily Chen",
    role: "Property Manager",
    content: "Managing multiple properties means I need reliable suppliers. Midtown Earth Solutions never disappoints. Fair pricing, quality materials, and dependable service every single time.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What areas do you deliver to?",
    answer: "We provide delivery services throughout Columbus, GA, Phenix City, AL, Harris County, GA, and Muscogee County, GA. Same-day delivery is available for Columbus and Muscogee County orders placed before noon."
  },
  {
    id: 2,
    question: "How do you calculate delivery fees?",
    answer: "Delivery fees are based on distance from our yard, material quantity, and delivery location accessibility. We provide transparent pricing with no hidden fees. Call us at +1 706-366-3685 for an instant quote."
  },
  {
    id: 3,
    question: "What is your minimum order quantity?",
    answer: "Our minimum order is typically 1 cubic yard or 1 ton, depending on the material. For smaller quantities or sample orders, please contact us directly and we'll do our best to accommodate your needs."
  },
  {
    id: 4,
    question: "Do you offer same-day delivery?",
    answer: "Yes! Same-day delivery is available for orders placed before noon in Columbus and Muscogee County. For other service areas, we typically offer next-day delivery. Rush delivery may be available - call us to check availability."
  },
  {
    id: 5,
    question: "Can I pick up materials myself?",
    answer: "Absolutely! Customer pickup is available at our yard located at 1127 Virginia St, Columbus, GA 31901. Pickup orders often qualify for discounted pricing. Please call ahead to ensure your materials are ready."
  },
  {
    id: 6,
    question: "What payment methods do you accept?",
    answer: "We accept cash, all major credit cards, and business checks from established accounts. Payment is due upon delivery or pickup. We also offer account terms for qualifying contractors and businesses."
  }
];

export const deliveryServices = [
  {
    id: 1,
    title: "Residential Services",
    description: "Professional delivery and material supply for homeowners. Perfect for DIY projects, landscaping, and home improvement.",
    features: ["Driveway-friendly trucks", "Precise placement", "Small to medium orders", "Weekend availability", "Clean job sites", "Expert advice"],
    icon: "home"
  },
  {
    id: 2,
    title: "Commercial Services",
    description: "Reliable bulk supply and delivery for contractors, builders, landscapers, and commercial developments. Volume pricing available.",
    features: ["Bulk pricing", "Account terms", "Scheduled deliveries", "Multiple drop-offs", "Large quantity orders", "Priority service"],
    icon: "building"
  },
  {
    id: 3,
    title: "Same-Day Service",
    description: "Need materials fast? Our same-day delivery service ensures your project stays on schedule. Available for both residential and commercial.",
    features: ["Orders by noon", "Columbus & Muscogee County", "Emergency delivery", "No rush fees", "Reliable scheduling", "Professional drivers"],
    icon: "clock"
  }
];

export const customerSegments = [
  {
    id: 1,
    title: "Residential Customers",
    description: "Homeowners trust us for quality materials to enhance their properties.",
    benefits: [
      "Driveway repairs & installations",
      "Garden bed materials",
      "Landscaping projects",
      "Backyard improvements",
      "DIY-friendly quantities",
      "Personal service"
    ]
  },
  {
    id: 2,
    title: "Commercial Clients",
    description: "Contractors, builders, and businesses rely on our bulk supply and dependable service.",
    benefits: [
      "Construction projects",
      "Property development",
      "Commercial landscaping",
      "Municipal projects",
      "Bulk volume pricing",
      "Account credit terms"
    ]
  }
];
